import { lazy } from 'react';
import ShippingTypeForm from './ShippingTypeForm';
import ShippingTypeList from './ShippingTypeList';

const ShippingTypeConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/shippingType',
            element: <ShippingTypeList />,
        },
        {
            path: '/addShippingType',
            element: <ShippingTypeForm />,
        },
        {
            path: '/editShippingType/:id',
            element: <ShippingTypeForm />,
        },
    ],
};

export default ShippingTypeConfig;
